export default __webpack_public_path__ + "static/media/icon-fb.c892cc4a.svg";